import WatersEdgeTheme from "./WatersEdgeTheme";

export default WatersEdgeTheme;